<template>
<span class="text-danger align-middle d-inline-block mx-1 font-weight-bolder">*</span>
</template>

<script>
export default {
  name: "req-field"
}
</script>
